const { formatField } = require('../../../../formatting')
const { getAgeFromSsn } = require('./get-age-from-ssn')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string|number} string
 * @returns {string|undefined}
 */
function getFullSsn (string) {
  if (!string) return

  const ssn = formatField({ country: 'se', value: string, format: 'ssn' })
  if (ssn.length === 13) return ssn

  const age = getAgeFromSsn(ssn)

  let century = new Date().getFullYear() - age
  century = century.toString().substr(0, 2)

  return `${century}${ssn}`
}

module.exports = { getFullSsn }
